import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { Button } from './ui/button';
import { FileText, ChevronRight } from 'lucide-react';

export const OpenProposalsSection = () => {
  const { t } = useLanguage();

  return (
    <section className="relative py-20 md:py-32 overflow-hidden">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-primary/10 rounded-full blur-[120px] pointer-events-none" />

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="glass-card rounded-2xl p-8 md:p-12 animate-fade-in">
          {/* Icon */}
          <div className="w-16 h-16 rounded-2xl bg-primary/20 flex items-center justify-center mx-auto mb-6">
            <FileText className="w-8 h-8 text-primary" />
          </div>

          {/* Content */}
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-testid="open-proposals-headline">
            {t('openProposals.headline')}
          </h2>
          
          <p className="text-lg text-slate-300 mb-8 max-w-2xl mx-auto">
            {t('openProposals.description')}
          </p>

          {/* CTA */}
          <Link to="/apply?type=custom" data-testid="open-proposals-cta">
            <Button size="lg" className="glow-primary group">
              {t('openProposals.cta')}
              <ChevronRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};
